import { render, staticRenderFns } from "./UnidadList.vue?vue&type=template&id=5696ca96&scoped=true&"
import script from "./UnidadList.vue?vue&type=script&lang=js&"
export * from "./UnidadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5696ca96",
  null
  
)

export default component.exports